import React from 'react';
import PropTypes from 'prop-types';
import Overlay from '../overlay';
import Text from '../type/text';
import AlertFooter from './__partials/alert-footer';

import './style.scss';

const Alert = ({ isOpen, text, onAfterOpen, actions, qaId }) => {
  return (
    <Overlay
      isOpen={isOpen}
      allowCloseOnOverlayClick={false}
      allowCloseOnEsc={false}
      className="uni-alert"
      onAfterOpen={onAfterOpen}
      qaId={qaId}
    >
      <div id="overlayContent" className="uni-alert__content">
        <Text level="default">{text}</Text>
      </div>

      <AlertFooter actions={actions} />
    </Overlay>
  );
};

Alert.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  text: PropTypes.string.isRequired,
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.oneOf(['primary', 'secondary', 'destroy', 'confirm', 'subtle', 'cancel']),
      label: PropTypes.string.isRequired,
      status: PropTypes.oneOf(['spinning', 'success', 'failure']),
      qaId: PropTypes.string,
      actionRef: PropTypes.func,
      onClick: PropTypes.func.isRequired,
    })
  ),
  qaId: PropTypes.string,
  onAfterOpen: PropTypes.func,
};

export default Alert;



// WEBPACK FOOTER //
// ./src/alert/index.jsx